import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../../comum/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';

import { AppServicesModule } from '../services/app.services.module';
import { DadosClienteComponent } from './dados-cliente/dados-cliente.component';
import { EnviarPedidoComponent } from './enviar-pedido/enviar-pedido.component';
import { FormaPagamentoComponent } from './forma-pagamento/forma-pagamento.component';
import { Routes, RouterModule, PreloadAllModules  } from '@angular/router';


export const routes: Routes = [
  { path: 'fechamento', component:DadosClienteComponent},
  { path: 'pagamento', component:FormaPagamentoComponent},
  { path: 'enviar', component:EnviarPedidoComponent}
];


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
    FormsModule, ReactiveFormsModule,
    AppServicesModule,
    MaterialModule,
    FlexLayoutModule,
  ],
  declarations: [DadosClienteComponent, 
    EnviarPedidoComponent, FormaPagamentoComponent]
  ,
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA,
  ]  
})
export class FechamentoModule { }
